import { useEffect, useState } from 'react'
import SmallCard from './SmallCard'
import style from './SideBar.module.css'
import { graphSidebarData } from '../GraphsensorsPortData'
import { connect } from 'react-redux'

const Sidebar = ({
    portsData,
    isSelectAll,
    setSelectAll,
    reduxInternalaccessories,
    isSelectInternalAccessories,
    stopFuntionRef,
}) => {
    // const [cards, setCards] = useState([
    //     {
    //         id: 1,
    //         title: 'Temperature',
    //         color: 'red',
    //         selected: true,
    //         expanded: false,
    //         details: [
    //             { label: 'Current', value: '23°C' },
    //             { label: 'Min', value: '18°C' },
    //             { label: 'Max', value: '28°C' },
    //             { label: 'Humidity', value: '65%' },
    //         ],
    //     },
    //     {
    //         id: 2,
    //         title: 'Distance Sens...',
    //         color: 'green',
    //         selected: false,
    //         expanded: false,
    //         details: [
    //             { label: 'Range', value: '0-100m' },
    //             { label: 'Accuracy', value: '±1cm' },
    //             { label: 'Status', value: 'Active' },
    //             { label: 'Last Update', value: '2s ago' },
    //         ],
    //     },
    //     {
    //         id: 3,
    //         title: 'Color Sensor',
    //         color: 'blue',
    //         selected: false,
    //         expanded: false,
    //         details: [
    //             { label: 'RGB', value: '255,128,64' },
    //             { label: 'Hex', value: '#FF8040' },
    //             { label: 'Brightness', value: '75%' },
    //             { label: 'Detected', value: 'Orange' },
    //         ],
    //     },
    // ])

    // const [selectAll, setSelectAll] = useState(false)

    // const handleCardSelect = (cardId) => {
    //     setCards((prevCards) =>
    //         prevCards.map((card) =>
    //             card.id === cardId
    //                 ? { ...card, selected: !card.selected }
    //                 : card
    //         )
    //     )
    // }

    // const handleCardExpand = (cardId) => {
    //     setCards((prevCards) =>
    //         prevCards.map((card) =>
    //             card.id === cardId
    //                 ? { ...card, expanded: !card.expanded }
    //                 : card
    //         )
    //     )
    // }

    const handleSelectAll = (e) => {
        try {
            stopFuntionRef.current()
            let newIsSelectInternalAccessories = JSON.parse(
                JSON.stringify(isSelectInternalAccessories)
            )
            let newPortsData = JSON.parse(JSON.stringify(portsData))
            if (e.target.checked) {
                Object.keys(graphSidebarData).map((cardKey, ind) => {
                    const card = graphSidebarData[cardKey]
                    // console.log('FFFFFFFFFFFFFFFFF', graphSidebarData, cardKey)
                    if (
                        [
                            'isDistanceSensors',
                            'isGestureSensor',
                            'colorsensorRed',
                            'colorsensorBlue',
                            'colorsensorGreen',
                            'isRedLight',
                            'isBlueLight',
                            'isGreenLight',
                            'isLightSensor',
                        ].includes(card.reduxName)
                    ) {
                        if (
                            !reduxInternalaccessories.Four_in_one_sensor[
                                card.reduxName
                            ]
                        ) {
                            return (newIsSelectInternalAccessories[
                                card.reduxName
                            ] = false)
                        }
                    } else if (!reduxInternalaccessories[card.reduxName]) {
                        return (newIsSelectInternalAccessories[
                            card.reduxName
                        ] = false)
                    }

                    newIsSelectInternalAccessories[card.reduxName] = true
                })

                //for external accessery doing select all
                newPortsData.map((portDetails) => {
                    portDetails.ports.map((port) => {
                        if (port.isActive) {
                            port.isChecked = true
                        }
                    })
                })
            } else {
                Object.keys(newIsSelectInternalAccessories).map((key) => {
                    newIsSelectInternalAccessories[key] = false
                })
                //for external accessery doing select all
                newPortsData.map((portDetails) => {
                    portDetails.ports.map((port) => {
                        if (port.isActive) {
                            port.isChecked = false
                        }
                    })
                })
            }
            setSelectAll({
                isSelectInternalAccessories: newIsSelectInternalAccessories,
                value: e.target.checked,
                portsData: newPortsData,
            })
        } catch (e) {
            console.log('ERROR', e)
        }
    }

    // Update selectAll state based on individual card selections
    // useEffect(() => {
    //     const allSelected = cards.every((card) => card.selected)
    //     const noneSelected = cards.every((card) => !card.selected)

    //     if (allSelected) {
    //         setSelectAll(true)
    //     } else if (noneSelected) {
    //         setSelectAll(false)
    //     }
    // }, [cards])

    return (
        <div className={style.sidebar}>
            <div className={style.cardWrapper}>
                {Object.keys(graphSidebarData).map((card, ind) => (
                    <SmallCard
                        ind={ind}
                        card={graphSidebarData[card]}
                        keyS={card}
                        stopFuntionRef={stopFuntionRef}
                        // key={ind}
                        // id={ind}
                        // title={card.title}
                        // color={card.bgColour}
                        // selected={card.selected}
                        // expanded={card.expanded}
                        // onSelect={() => handleCardSelect(card.id)}
                        // onToggleExpand={() => handleCardExpand(card.id)}
                        // details={card.details}
                    />
                ))}
                {portsData.map((portDeTails, mainInd) => {
                    return portDeTails.ports.map((port, minorInd) => (
                        <SmallCard
                            type="exterNalSensor"
                            port={port}
                            mainInd={mainInd}
                            minorInd={minorInd}
                            stopFuntionRef={stopFuntionRef}
                        />
                    ))
                })}
            </div>
            <div className={style.selectAllContainer}>
                {/* <label className={style.selectAllLabel}>
                    <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className={style.checkbox}
                    />
                
                    <span>Select all</span>
                </label> */}
                <span
                    style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        color: 'black',
                    }}
                >
                    Select all
                </span>
                <label className={style.checkboxWrapper}>
                    <input
                        type="checkbox"
                        checked={isSelectAll}
                        onChange={handleSelectAll}
                    />
                    <span className={style.checkmark}></span>
                </label>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        time: state.graphPlotStorage.time,
        isSelectInternalAccessories:
            state.graphPlotStorage.isSelectInternalAccessories,
        reduxInternalaccessories: state.graphPlotStorage.internalaccessories,
        portsData: state.graphPlotStorage.internalaccessories.portsData,
        isSelectAll: state.graphPlotStorage.isSelectAll,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectInternalAccessories: (data) => {
            dispatch({ type: 'SET_SELECT_INTERNAL_ACCESSORIES', payload: data })
        },
        setSelectAll: (data) => {
            dispatch({ type: 'SELECT_ALL', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)
